<div
  class="row"
  *ngIf="offer"
>
  <div class="col-8 border-right pe-5">
    <div class="row my-4">
      <p class="col-5 fw-bold">{{ 'mlp' | translate }}</p>
      <p class="col-7">{{ offer.mlp | baseFormatDate | baseIsEmpty }}</p>
    </div>
    <div class="row mb-4">
      <p class="col-5 fw-bold">{{ 'ep' | translate }}</p>
      <p class="col-7">{{ offer.ep | baseFormatDate | baseIsEmpty }}</p>
    </div>
    <div class="row mb-4">
      <p class="col-5 fw-bold">{{ 'operations.hourlyRating' | translate }}</p>
      <p class="col-7">{{ offer.hourlyRate | baseFormatDecimal }} €</p>
    </div>
    <div class="row mb-4">
      <p class="col-5 fw-bold">{{ 'surcharges.cancellationPeriod' | translate }}</p>
      <p class="col-7">
        {{ (!isCustomerOfferResponse(offer) ? offer.cancelationPeriod : '') | baseIsEmpty }}
        <ng-container *ngIf="!isCustomerOfferResponse(offer) && offer.cancelationPeriod">{{
          'relativeTime.hours' | translate
        }}</ng-container>
      </p>
    </div>
    <base-expansion-panel
      *ngIf="offer?.industrySurcharges"
      title="industrySurcharges.plural"
      titleClass="headline-24"
      class="d-block mb-4"
    >
      <base-industry-surcharges [surcharges]="offer.industrySurcharges!"></base-industry-surcharges>
    </base-expansion-panel>
    <div class="mb-4">
      <h5>{{ 'surcharges.plural' | translate }}</h5>
      <p class="fw-bold">{{ 'accordingToSpecification' | translate }}</p>
      <base-surcharges [surcharges]="offer.surcharges || []"></base-surcharges>
    </div>
  </div>

  <div class="col-4 location-info ps-5">
    <div class="my-4">
      <h5>{{ 'operations.assignmentLocation' | translate }}</h5>
      <span class="fw-medium">{{
        inquiry ? inquiry.customerLocation?.name : isCustomerOfferResponse(offer) ? offer.location.name : ''
      }}</span
      ><br />
      {{ inquiry ? inquiry.customerDepartment?.name : isCustomerOfferResponse(offer) ? offer.department?.name : ''
      }}<br />
      {{
        inquiry
          ? inquiry.customerDepartment?.businessAddress?.street
          : isCustomerOfferResponse(offer)
          ? offer.department?.businessAddress?.street
          : ''
      }}<br />
      {{
        inquiry
          ? inquiry.customerDepartment?.businessAddress?.postCode
          : isCustomerOfferResponse(offer)
          ? offer.department?.businessAddress?.postCode
          : ''
      }}
      {{
        inquiry
          ? inquiry.customerDepartment?.businessAddress?.city
          : isCustomerOfferResponse(offer)
          ? offer.department?.businessAddress?.city
          : ''
      }}

      <p class="fw-bold mt-4 mb-2">{{ 'billingAddress' | translate }}</p>
      <div class="d-flex flex-column">
        <span>{{
          inquiry
            ? inquiry.customerDepartment?.billingContact?.legalName
            : isCustomerOfferResponse(offer)
            ? offer.department?.billingContact?.legalName
            : ''
        }}</span>
        <span>{{
          inquiry
            ? inquiry.customerDepartment?.billingContact?.billingAddress?.street
            : isCustomerOfferResponse(offer)
            ? offer.department?.billingContact?.billingAddress?.street
            : ''
        }}</span>
        <span>
          {{
            inquiry
              ? inquiry.customerDepartment?.billingContact?.billingAddress?.postCode
              : isCustomerOfferResponse(offer)
              ? offer.department?.billingContact?.billingAddress?.postCode
              : ''
          }}
          {{
            inquiry
              ? inquiry.customerDepartment?.billingContact?.billingAddress?.city
              : isCustomerOfferResponse(offer)
              ? offer.department?.billingContact?.billingAddress?.city
              : ''
          }}
        </span>
        <span>{{
          inquiry
            ? inquiry.customerDepartment?.billingContact?.email
            : isCustomerOfferResponse(offer)
            ? offer.department?.billingContact?.email
            : ''
        }}</span>
      </div>
    </div>

    <div class="my-4">
      <h5>{{ 'provider' | translate }}</h5>
      {{ offer.pspBranch.legalName }}<br />
      {{ offer.pspBranch.businessAddress.street }}<br />
      {{ offer.pspBranch.businessAddress.postCode }} {{ offer.pspBranch.businessAddress.city }}<br />
      <div class="d-flex flex-row align-items-center gap-2 mt-2">
        <base-izs-rating
          [color]="offer.pspBranch.izsStatus"
          (click)="openIzsInfoModal($event)"
        ></base-izs-rating>
        <p class="m-0 fw-bold">{{ 'izs.rating' | translate }}</p>
      </div>
    </div>

    <p class="fw-bold mb-0 mt-2">{{ 'contactPerson' | translate }}</p>
    <p class="fw-bold mb-0 mt-2">{{ 'name' | translate }}</p>
    <span *ngIf="offer?.responsible">{{ offer.responsible?.firstName }} {{ offer.responsible?.lastName }}</span>
    <ng-container *ngIf="offer.responsible?.mobilePhone">
      <p class="fw-bold mb-0 mt-2">{{ 'externalEmployees.operationInfo.phone' | translate }}</p>
      <span>{{ offer.responsible?.mobilePhone }}</span>
    </ng-container>
    <ng-container *ngIf="offer.responsible?.email">
      <p class="fw-bold mb-0 mt-2">{{ 'externalEmployees.operationInfo.email' | translate }}</p>
      <span>{{ offer.responsible?.email }}</span>
    </ng-container>
    <p class="fw-bold mt-4 mb-2">{{ 'billingAddress' | translate }}</p>
    <div class="d-flex flex-column">
      <span>{{ offer.pspBranch.billingContact?.legalName }}</span>
      <span>{{ offer.pspBranch.billingContact?.billingAddress?.street }}</span>
      <span>
        {{ offer.pspBranch.billingContact?.billingAddress?.postCode }}
        {{ offer.pspBranch.billingContact?.billingAddress?.city }}
      </span>
      <span>{{ offer.pspBranch.billingContact?.email }}</span>
    </div>
  </div>
</div>
